/**
 * EventEntityName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityName from '../EntityName';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    entityId?: string;
}

export class EventEntityName extends React.PureComponent<Props> {
    render() {
        const { entityId } = this.props;
        return <EntityName entityId={entityId} hideEntityType />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityId: makeSelectEventValue('entityId')
});

export default connect(mapStateToProps)(EventEntityName);
